import type { KnowledgeArticle, Locale } from "../../content/types"
import { SITE_URL, SITE_NAME } from "../../content/site"
import { getPagePath } from "../../content/registry"

/**
 * Article schema for knowledge pages that genuinely function as articles.
 * Dates come from the article data itself — never fabricated for old content.
 */
export function buildArticleSchema(article: KnowledgeArticle, locale: Locale): object | null {
  const path = getPagePath(article.id as never, locale)
  if (!path) return null

  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title[locale],
    description: article.description[locale],
    datePublished: article.published,
    dateModified: article.modified || article.published,
    author: {
      "@type": "Person",
      name: article.author,
    },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/SCHMEITZ_DE_GROEN.svg`,
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${SITE_URL}${path}`,
    },
    inLanguage: locale === "nl" ? "nl-NL" : "en",
  }
}

/** Person schema used on the about page where founder bios are visible. */
export function buildFoundersSchema(): object[] {
  return [
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Rutger de Groen",
      jobTitle: "Co-Founder",
      worksFor: { "@type": "Organization", name: SITE_NAME },
      alumniOf: { "@type": "CollegeOrUniversity", name: "Maastricht University" },
    },
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Camiel Schmeitz",
      jobTitle: "Co-Founder",
      worksFor: { "@type": "Organization", name: SITE_NAME },
      alumniOf: { "@type": "CollegeOrUniversity", name: "Maastricht University" },
    },
  ]
}
